import React, { useContext, useEffect, useState } from 'react';
import B2BPopUpForm from '../../b2b-common/B2BPopUpForm';
import { Add, Block, Delete, DeveloperBoard, Save } from '@mui/icons-material';
import { LoginContext } from '../../../App';
import LabelTranslated from '../../b2b-languages/components/LabelTranslated';
import B2BTableInMemory from '../../b2b-common/B2BTableInMemory';
import WeigthedValueForm from '../components/WeigthedValueForm';
import Frame from '../../b2b-common/Frame';
import { Divider } from '@mui/material';

import './QualTypeModal.css';
import { deleteQualitativeType, deleteQualitativeTypeWeightValue, fetchQualitativeTypeData, saveNewQualitativeType, updateQualitativeType, updateQualitativeTypeWeightValue } from '../../../services/b2b-indicators-apiService';
import { fetchAPIDataWhileSettingState } from '../../b2b-common/helpers';
import { updateObjectFieldsWithLabels } from '../../b2b-languages/components/helper';

const QualTypeModal = ({ open, toChangeQualTypeId = null, onUpdate, onClose }) => {

    const { loginData } = useContext(LoginContext);
    const emptyQualType = {
        "qualitativeTypeId": null,
        "qualitativeTypeName": null,
        "qualitativeTypeName_label": null,
        "qualitativeTypeDescription": null,
        "qualitativeTypeDescription_label": null,
        "weightedValues": [],
    };
    const emptyWeightedValue = {
        "qualitativeWeightedValueId": 0,
        "qualitativeTypeId": 0,
        "qualitativeWeightedLabel": null,
        "qualitativeWeightedDescription": null,
        "qualitativeWeightedValue": 0
    }
    const [type, setType] = useState(emptyQualType);

    // NEW TYPE

    const handleSaveNewType = async () => {
        //console.log('Saving new type:', type);
        try {
            const updatedType = updateObjectFieldsWithLabels(type);
            updatedType.weightedValues = updatedType.weightedValues.map(value => updateObjectFieldsWithLabels(value));
            //console.log('Updated Type:', updatedType);
            const newType = await fetchAPIDataWhileSettingState(saveNewQualitativeType, [type, loginData.accessToken]);
            // console.log('New Type:', newType);
            setType(emptyQualType);
            onUpdate();
            onClose();
        } catch (error) {
            console.error(error);
        }
    }

    const buttonsNewType = [
        {
            label: 'Save new type',
            icon: <Add />,
            onClick: handleSaveNewType,
        },
    ];

    // UPDATE TYPE

    const handleUpdateType = async () => {
        console.log('Updating type:', type);
        try {
            const updatedType = updateObjectFieldsWithLabels(type);
            updatedType.weightedValues = updatedType.weightedValues.map(value => updateObjectFieldsWithLabels(value));
            // console.log('Updated Type:', updatedType);
            const newType = await fetchAPIDataWhileSettingState(updateQualitativeType, [updatedType, loginData.accessToken]);
            // console.log('Updated Type:', newType);
            setType(emptyQualType);
            onUpdate();
            onClose();
        } catch (error) {
            console.error(error);
        }
    }

    const handleDeleteType = async () => {
        console.log('Deleting type:', type);
        try {
            await fetchAPIDataWhileSettingState(deleteQualitativeType, [type.qualitativeTypeId, loginData.accessToken]);
            // console.log('Deleted Type:', deletedType);
            setType(emptyQualType);
            onUpdate();
            onClose();
        } catch (error) {
            console.error(error);
        }
    }

    const getQualitativeType = async (qualitativeTypeId) => {
        console.log('Getting Qual Type:', qualitativeTypeId);
        try {
            const qualType = await fetchAPIDataWhileSettingState(fetchQualitativeTypeData, [qualitativeTypeId, loginData.accessToken]);
            console.log('Qual Type:', qualType);
            setType(qualType);

        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        if (toChangeQualTypeId) {
            console.log('Update type:', toChangeQualTypeId);
            getQualitativeType(toChangeQualTypeId);
        }
    }, [toChangeQualTypeId]);

    const buttonsUpdateType = [
        {
            label: 'Update type',
            icon: <Save />,
            onClick: handleUpdateType,
        },
        {
            label: 'Delete type',
            icon: <Delete />,
            confirm: true,
            onConfirm: handleDeleteType,
        },
    ];

    const handleClose = () => {
        setType(emptyQualType);
        onClose();
    }

    // WEIGHTED VALUES

    const headers = [
        { label: 'Id', align: 'center' },
        { label: 'Label', align: 'left' },
        { label: 'Value', align: 'center' },
    ];

    const returnIdOrRemoveButton = (id) => {
        return id === 0 ? <Block /> : id;
    }

    const rows = type.weightedValues
        ? type.weightedValues
            .map((value) => ({
                id: value.qualitativeWeightedValueId,
                cells: [
                    { content: returnIdOrRemoveButton(value.qualitativeWeightedValueId), align: 'center' },
                    { content: value.qualitativeWeightedLabel_label, align: 'left' },
                    { content: value.qualitativeWeightedValue, align: 'center' },
                ],
            }))
        : [];

    // NEW WEIGHTED VALUE

    const [showNewWeightedValueFrame, setShowNewWeightedValueFrame] = useState(false);
    const handleNewWeightedValue = (newWeightedValue) => {
        console.log('New Weighted Value:', newWeightedValue);
        setType({
            ...type,
            weightedValues: [...type.weightedValues, newWeightedValue].sort((a, b) => a.qualitativeWeightedValue - b.qualitativeWeightedValue),
        });
    }

    // EXISTING WEIGHTED VALUE

    const [showExistingWeightedValueFrame, setShowExistingWeightedValueFrame] = useState(false);
    const [selectedWeightedValue, setSelectedWeightedValue] = useState(null);

    const handleUpdateExistingWeightedValue = async (updatedWeightedValue) => {
        //console.log('Updated Weighted Value:', updatedWeightedValue);
        try {
            const toSaveWeightedValue = updateObjectFieldsWithLabels(updatedWeightedValue);
            const savedWeightedValue = await fetchAPIDataWhileSettingState(updateQualitativeTypeWeightValue,
                [toSaveWeightedValue, loginData.accessToken]);
            //console.log('Updated Weighted Value:', savedWeightedValue);
            setType({
                ...type,
                weightedValues: type.weightedValues.map(value => value.qualitativeWeightedValueId === savedWeightedValue.qualitativeWeightedValueId ? savedWeightedValue : value)
            });
            onUpdate();
        } catch (error) {
            console.error(error);
        }
    }

    const handleDeleteExistingWeightedValue = async (deletedWeightedValue) => {
        console.log('Deleted Weighted Value:', deletedWeightedValue);
        try {
            await fetchAPIDataWhileSettingState(deleteQualitativeTypeWeightValue, [deletedWeightedValue, loginData.accessToken]);
            //console.log('Deleted Weighted Value:', deletedWeightedValue);
            setType({
                ...type,
                weightedValues: type.weightedValues.filter(value => value.qualitativeWeightedValueId !== deletedWeightedValue.qualitativeWeightedValueId)
            });
            onUpdate();
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <B2BPopUpForm
            open={open}
            icon={<DeveloperBoard />}
            title={toChangeQualTypeId ? 'Update type' : 'New type'}
            onClose={handleClose}
            buttons={toChangeQualTypeId ? buttonsUpdateType : buttonsNewType}
            className="b2b-qualitative-type-modal"
        >
            <LabelTranslated
                field="Name" labelValue={type.qualitativeTypeName_label}
                onChange={(e) => setType({ ...type, qualitativeTypeName_label: e.target.value })}
                locale={`Name [${loginData.locale}]`} translation={type.qualitativeTypeName} />
            <LabelTranslated
                field="Description" labelValue={type.qualitativeTypeDescription_label}
                onChange={(e) => setType({ ...type, qualitativeTypeDescription_label: e.target.value })}
                locale={`Description [${loginData.locale}]`} translation={type.qualitativeTypeDescription} />
            <Divider />
            <Frame title="Weighted values" className='qualitative-type-weighted-values'>
                <B2BTableInMemory
                    headers={headers}
                    rows={rows}
                    className={"qualitative-type-weighted-values-table"}
                    numRows={5}
                    stickyHeader={false}
                    onRowClick={(row) => {
                        console.log('Selected Weighted Value:', row);
                        if (row.id !== 0) {
                            setShowExistingWeightedValueFrame(true);
                            setSelectedWeightedValue(type.weightedValues.find(value => value.qualitativeWeightedValueId === row.id));
                        }
                    }}
                    buttons={[
                        {
                            label: 'New Value',
                            disabledText: 'New Value',
                            onClick: () => {
                                setShowNewWeightedValueFrame(true);
                                setSelectedWeightedValue(emptyWeightedValue);
                            },
                            color: 'secondary',
                            variant: 'contained',
                            key: '1',
                            icon: <Add />,
                        },
                    ]}
                />
                {showNewWeightedValueFrame && (
                    <WeigthedValueForm
                        onClose={() => {
                            setShowNewWeightedValueFrame(false);
                        }}
                        onUpdate={handleNewWeightedValue}
                    />
                )}
                {showExistingWeightedValueFrame && (
                    <WeigthedValueForm
                        weightedValue={selectedWeightedValue}
                        onClose={() => {
                            setShowExistingWeightedValueFrame(false);
                        }}
                        onDelete={handleDeleteExistingWeightedValue}
                        onUpdate={handleUpdateExistingWeightedValue}
                    />
                )}
            </Frame>
        </B2BPopUpForm>

    );
};

export default QualTypeModal;